"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    translation: _propTypes.default.shape({
      personalDetails: _propTypes.default.string,
      givenName: _propTypes.default.string,
      familyName: _propTypes.default.string,
      nationality: _propTypes.default.string,
      gender: _propTypes.default.string,
      male: _propTypes.default.string,
      female: _propTypes.default.string,
      dateOfBirth: _propTypes.default.string,
      adult: _propTypes.default.string,
      child: _propTypes.default.string,
      infant: _propTypes.default.string,
      adultAgeError: _propTypes.default.string,
      infantAgeError: _propTypes.default.string,
      childAgeError: _propTypes.default.string,
      dateError: _propTypes.default.string,
      requiredError: _propTypes.default.string,
      yptaDisclaimerTitle: _propTypes.default.string,
      seniorCitizenId: _propTypes.default.string,
      hasInfantError: _propTypes.default.string,
      firstNameMaxError: _propTypes.default.string,
      familyNameMaxError: _propTypes.default.string,
      totalNameMaxError: _propTypes.default.string
    }),
    nationalities: _propTypes.default.arrayOf(_propTypes.default.shape({
      cultureCode: _propTypes.default.string,
      countryCode3C: _propTypes.default.string,
      dialingCode: _propTypes.default.string,
      countryCode: _propTypes.default.string,
      name: _propTypes.default.string,
      defaultCurrencyCode: _propTypes.default.string,
      label: _propTypes.default.string,
      value: _propTypes.default.string
    })),
    paxType: _propTypes.default.string,
    flightDate: _propTypes.default.string,
    formRef: _propTypes.default.object,
    onSubmit: _propTypes.default.func,
    initialValues: _propTypes.default.shape({
      givenName: _propTypes.default.string,
      familyName: _propTypes.default.string,
      nationality: _propTypes.default.string,
      gender: _propTypes.default.string,
      dateOfBirth: _propTypes.default.string,
      seniorCitizenId: _propTypes.default.string
    }),
    hasPopover: _propTypes.default.bool,
    paxAgeRange: _propTypes.default.shape({
      adult: _propTypes.default.shape({
        min: _propTypes.default.number
      }),
      child: _propTypes.default.shape({
        min: _propTypes.default.number,
        max: _propTypes.default.number
      }),
      infant: _propTypes.default.shape({
        min: _propTypes.default.number,
        max: _propTypes.default.number
      })
    }),
    travellingWithList: _propTypes.default.array,
    gtmParameters: _propTypes.default.object,
    fireGtm: _propTypes.default.func,
    gender: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      value: _propTypes.default.string
    })),
    isWMP: _propTypes.default.bool,
    autoSelectNationalityOneResult: _propTypes.default.bool,
    showNationality: _propTypes.default.bool,
    showGivenName: _propTypes.default.bool,
    showFamilyName: _propTypes.default.bool,
    showGenderField: _propTypes.default.bool,
    showDOBField: _propTypes.default.bool,
    newYpta: _propTypes.default.bool,
    yptaDisclaimerContent: _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.node]),
    yptaAgeRange: _propTypes.default.shape({
      min: _propTypes.default.number,
      max: _propTypes.default.number
    }),
    exactYptaAgeValidation: _propTypes.default.bool,
    showSeniorCitizen: _propTypes.default.bool,
    seniorCitizenMinimumAge: _propTypes.default.shape({
      min: _propTypes.default.number
    }),
    hasInfant: _propTypes.default.bool,
    maxCharLengthAllowed: _propTypes.default.number,
    allowedNameLength: _propTypes.default.shape({
      givenNameLength: _propTypes.default.number,
      familyNameLength: _propTypes.default.number,
      totalNameLength: _propTypes.default.number
    }),
    singleClickGender: _propTypes.default.bool,
    color: _propTypes.default.string,
    selectButtonBackgroundColor: _propTypes.default.string,
    selectedButtonBorderColor: _propTypes.default.string,
    customButtonWidth: _propTypes.default.string,
    checkSeniorCitizenField: _propTypes.default.func,
    initialValuesCallback: _propTypes.default.func,
    sortNationlityByCultureCode: _propTypes.default.string
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    translation: {},
    onSubmit: function onSubmit() {},
    handleField: function handleField() {},
    initialValues: _constant2.INITIAL_VALUES,
    hasPopover: false,
    paxAgeRange: {},
    travellingWithList: [],
    isWMP: false,
    autoSelectNationalityOneResult: true,
    showNationality: true,
    showGivenName: true,
    showFamilyName: true,
    showGenderField: true,
    showDOBField: true,
    showSeniorCitizen: false,
    hasInfant: false,
    singleClickGender: false,
    color: _constant2.SINGLE_SELECT.color,
    selectButtonBackgroundColor: _constant2.SINGLE_SELECT.backgroundColor,
    selectedButtonBorderColor: _constant2.SINGLE_SELECT.borderColor,
    customButtonWidth: _constant2.SINGLE_SELECT.width,
    checkSeniorCitizenField: function checkSeniorCitizenField() {},
    newYpta: false,
    exactYptaAgeValidation: false
  }
};
exports.default = _default;